<template>
    <div>
        <div style="width: 220px;">
            <div class="search-container primary mb15 mt10">
                <div class="form-box">
                    <input class="input-field" v-model="name" placeholder="请输入供应商名称"/>
                    <button class="search-btn" @click="getVendorList()"><i class="icon iconfont icon-search"></i></button>
                </div>
            </div>
        </div>
        <hr/>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="vendorList" border tooltip-effect="dark" style="width: 100%" @select="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55"></el-table-column>
                <el-table-column align="left" prop="name" show-overflow-tooltip label="商户名称"></el-table-column>
                <el-table-column prop="vsFlag" label="买方关联" align="center" width="100">
                    <template slot-scope="rows">
                        <el-tag type="success" v-if="rows.row.vsFlag">买方关联</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="right" width="120" prop="registCapital" label="注册资金（万元）">
                    <template slot-scope="scope">
                        <span>{{(parseFloat(scope.row.registCapital) / 10000).toFixed(2) || '0.00'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="150" prop="contactName" label="联系人"></el-table-column>
                <el-table-column align="left" width="120" prop="contactTel" label="联系电话"></el-table-column>
                <el-table-column align="left" width="200" prop="contactEmail" label="联系邮箱"></el-table-column>
                <el-table-column align="center" width="120" prop="foundDate" label="成立日期"></el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import vendorApi from '../../api/vendor'

    export default {
        name: 'swb-vendor-list-for-select',
        desc: '供应商-选择',
        props: ['rowId', 'isMultiple', 'empty', 'includeHidden'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                vendorList: [],
                name: null,
                multipleSelection: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getVendorList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getVendorList();
            },
            getVendorList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                let filterItems = {};
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                if(self.includeHidden == 0){
                    filterItems.hidden = false;
                }else if(self.includeHidden == 1){
                    filterItems.hidden = true;
                }
                postData.filterItems = filterItems;
                vendorApi.getVendorList(postData, function (result) {
                    if(result.type === "info") {
                        self.vendorList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.selectTable();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleSelectionChange(selection, row) {
                if(this.isMultiple) {
                    this.multipleSelection = selection;
                } else if(this.empty) {
                    if(this.multipleSelection != null && this.multipleSelection.id == row.id) {
                        this.$refs.multipleTable.clearSelection();
                        this.multipleSelection = null;
                        return;
                    }
                    this.multipleSelection = row;
                } else {
                    this.$refs.multipleTable.clearSelection(selection);
                    this.$refs.multipleTable.toggleRowSelection(row);
                    this.multipleSelection = row;
                }
            },
            selectTable: function () {
                if(this.rowId != null) {
                    setTimeout(() => {
                        let vendorList = this.vendorList;
                        for(var i = 0; i < vendorList.length; i++) {
                            if(vendorList[i].id == this.rowId) {
                                this.$refs.multipleTable.toggleRowSelection(vendorList[i]);
                                this.multipleSelection = vendorList[i];
                                break;
                            }
                        }
                    }, 10);
                }
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multipleSelection = self.multipleSelection;
                if(multipleSelection != null) {
                    result.type = 'info';
                    result.data = multipleSelection;
                } else {
                    result.type = 'warn';
                    result.message = '请选择一个供应商！';
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/vendor/VendorListForSelect.vue